/* eslint-disable react/jsx-key */
import { Link } from '@apollo/orbit';
import React from 'react';

import { DocsRouter } from 'src/lib/routers';

export const wellKnownErrorCodes = new Map([
  [
    '# AgentCardinalityLimitExceeded',
    <>
      The original error code is not available due to hitting cardinality limits
      in the reporting agent.
    </>,
  ],
  [
    'CANNOT_SEND_PQ_ID_AND_BODY',
    <>
      The operation could not be executed because sending a persisted query ID
      and a body in the same request is disallowed.
    </>,
  ],
  [
    'CONNECTOR_FETCH',
    <>There was an error fetching data from a connector service.</>,
  ],
  [
    'COST_ESTIMATED_TOO_EXPENSIVE',
    <>
      The operation was not executed because it exceeded allowed cost
      calculations.
    </>,
  ],
  [
    'GATEWAY_TIMEOUT',
    <>There request timed out when fetching data from a federated service.</>,
  ],
  [
    'GRAPHQL_VALIDATION_FAILED',
    <>The operation failed during GraphQL validation.</>,
  ],
  [
    'GRAPHQL_UNKNOWN_OPERATION_NAME',
    <>
      The operation could not be executed because the operation name was invalid
      or did not match an operation in the query document.
    </>,
  ],
  [
    'HTTP_CLIENT_ERROR',
    <>
      There was an error at the HTTP transport layer when fetching data from a
      connector service.
    </>,
  ],
  [
    'MAX_ALIASES_LIMIT',
    <>The operation was not executed due to exceeding the max_aliases limit.</>,
  ],
  [
    'MAX_DEPTH_LIMIT',
    <>The operation was not executed due to exceeding the max_depth limit.</>,
  ],
  [
    'MAX_HEIGHT_LIMIT',
    <>The operation was not executed due to exceeding the max_height limit.</>,
  ],

  [
    'MAX_ROOT_FIELDS_LIMIT',
    <>
      The operation was not executed due to exceeding the max_root_fields limit.
    </>,
  ],
  [
    'QUERY_NOT_IN_SAFELIST',
    <>
      The operation was not executed because it was not found in the persisted
      query safelist.
    </>,
  ],
  ['PARSING_ERROR', <>The operation could not be parsed as GraphQL.</>],
  [
    'PERSISTED_QUERY_HASH_MISMATCH',
    <>
      The operation was not executed due to a mismatch with the automatic
      persisted query (APQ) protocol. There was an attempt to store this
      operation in the APQ cache, but the provided hash did not match the
      operation.
    </>,
  ],
  [
    'PERSISTED_QUERY_NOT_FOUND',

    <>
      The operation was not executed since it was not found in the automatic
      persisted query (APQ) cache. This is an expected behavior when using the
      APQ protocol.
    </>,
  ],
  [
    'PERSISTED_QUERY_NOT_SUPPORTED',

    <>
      An operation attempted to use automatic persisted queries, but the feature
      was not enabled.
    </>,
  ],
  [
    'PERSISTED_QUERY_NOT_IN_LIST',
    <>
      The operation was not executed because it was not found in the persisted
      query safelist.
    </>,
  ],
  [
    'REQUEST_LIMIT_EXCEEDED',
    <>
      There was an error due to exceeding the max requests configuration for a
      connector service.
    </>,
  ],
  [
    'RESPONSE_VALIDATION_FAILED',
    <>
      The response returned from a subgraph failed validation for the supergraph
      schema.
    </>,
  ],
  [
    'SUBREQUEST_HTTP_ERROR',
    <>
      There was an error at the HTTP transport layer when fetching data from a
      subgraph service.
    </>,
  ],
  [
    'UNAUTHORIZED_FIELD_OR_TYPE',
    <>
      The operation was not fully executed because it attempted to use a field
      or type was unauthorized.
    </>,
  ],
  [
    '',
    <>
      The error was not reported with a code.{' '}
      <span className="whitespace-nowrap">
        Learn how to{' '}
        <Link isExternal to={DocsRouter.path('ExtendedErrorConfig')}>
          report error codes
        </Link>{' '}
      </span>
      in the docs.
    </>,
  ],
]);
